import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export type TransferStatus = 'completed' | 'failed';

export interface TransferListItem {
  id: string;
  senderTelegramId: string;
  senderName: string;
  senderPhone: string;
  receiverTelegramId: string;
  receiverName: string;
  receiverPhone: string;
  amount: number;
  currency: string;
  status: TransferStatus;
  senderBalanceAfter: number;
  receiverBalanceAfter: number;
  note: string;
  createdAt: string;
}

export interface TransferDetail extends TransferListItem {
  updatedAt: string;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface TransfersResponse {
  transfers: TransferListItem[];
  pagination: Pagination;
}

export interface GetTransfersParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: 'all' | TransferStatus;
  fromDate?: string;
  toDate?: string;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class TransferService {
  async getAll(params: GetTransfersParams = {}): Promise<TransfersResponse> {
    const res = await apiClient.get<ApiEnvelope<TransfersResponse>>(
      API_ENDPOINTS.TRANSFERS.GET_ALL,
      { params }
    );
    return res.data.data;
  }

  async getOne(id: string): Promise<TransferDetail> {
    const res = await apiClient.get<ApiEnvelope<TransferDetail>>(
      API_ENDPOINTS.TRANSFERS.GET_ONE(id)
    );
    return res.data.data;
  }
}

const transferService = new TransferService();
export default transferService;